import { Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { RadioOption } from "@/components/shared/radio-list/radio-list.component";
import { USER_IS_AT_LEAST_ADMIN } from "@/_services";
import { Observable } from "rxjs";

@Component({
    selector: "app-template-list-filter-sidebar",
    templateUrl: "./template-list-filter-sidebar.component.html",
    styleUrl: "./template-list-filter-sidebar.component.scss",
})
export class TemplateListFilterSidebarComponent {
    @Input() filterForm: UntypedFormGroup;
    @Output() closeButtonClicked: EventEmitter<void> = new EventEmitter<void>();

    @Input() typeList: RadioOption[] = [];
    @Input() industryList: RadioOption[] = [];

    constructor(
        @Inject(USER_IS_AT_LEAST_ADMIN) public isAdmin$: Observable<boolean>,
    ) {}

    ngOnInit() {}

    // Filter values are compared exact-case against the option list and the
    // stored data (e.g. FormType.confidentialReporting), so lowercasing here
    // silently broke every filter option with an uppercase letter: the
    // checkbox couldn't even show itself as checked afterward, and the
    // request sent a value nothing could ever match.
    setCheckboxValue(control: UntypedFormControl, state: boolean, value: any) {
        if (state) {
            return control.setValue([...control.value, value]);
        }
        return control.setValue([
            ...control.value.filter((currentValue) => currentValue !== value),
        ]);
    }

    close() {
        this.closeButtonClicked.emit();
    }
}
